import { render, staticRenderFns } from "./RoleView.vue?vue&type=template&id=5665bb8d&scoped=true"
import script from "./RoleView.vue?vue&type=script&lang=js"
export * from "./RoleView.vue?vue&type=script&lang=js"
import style0 from "./RoleView.vue?vue&type=style&index=0&id=5665bb8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5665bb8d",
  null
  
)

export default component.exports